import Header from "../Settings/Header";
import SettingPage from "../common/SettingPage";
import { __, sprintf } from "@wordpress/i18n";
import VideosTable from "./VideosTable";
import StickyWidget from "../StickyWidget";
import { ReactComponent as Add } from "../assets/add_new.svg";
import LicenseNotice from "../common/LicenseNotice";
import ImporterPopup from "./ImporterPopup";
import "../style/single_videos.css";
import { useState } from "react";
import { ReactComponent as Cog } from "../assets/cog.svg";
import ReactTooltip from "react-tooltip";

const SingleVideos = () => {
  const [showImportPopup, setShowImportPopup] = useState(false);

  return (
    <>
      {window.sby_settings.shouldShowPostGracePeriodNotice ? (
        <LicenseNotice />
      ) : null}
      <Header title={__("Single Videos", "feeds-for-youtube")} />
      <SettingPage
        headerJustification="justify-start"
        headerButton={
          <div className="sby-single-videos-header-children flex flex-row flex-grow">
            <span
              data-tip={sprintf(
                __(
                  "Please go to <a href='%s'>Settings</a> and enter an API key to activate the importer tool.",
                  "feeds-for-youtube"
                ),
                window.sby_settings.settingsPageUrl
              )}
              data-tip-disable={false}
              data-html={true}
            >
              <button
                onClick={() => {
                  setShowImportPopup(true);
                }}
                className="sb-btn-orange sby-importer-btn px-3 flex flex-row align-baseline"
                disabled={!window.sby_settings.settings.api_key}
              >
                <Add className="mr-1" height="9" />
                <span className="mt-1">
                  {__("Import Videos", "feeds-for-youtube")}
                </span>
              </button>
            </span>
            {!window.sby_settings.settings.api_key && (
              <ReactTooltip
                className="sby-tooltip"
                place="top"
                effect="solid"
                arrowColor="#2C324C"
                clickable={true}
              />
            )}
            <a
              href={window.sby_settings.single_videos_list}
              className="sb-btn sb-btn-grey ml-2"
            >
              {__("View All Videos", "feeds-for-youtube")}
            </a>
            <a
              href={window.sby_settings.single_video_admin_url}
              className="sb-btn sb-btn-sm sb-btn-grey ml-2"
            >
              <Cog height={13} width={13} />
            </a>
          </div>
        }
        title={__("Single Videos", "feeds-for-youtube")}
        headerClassName="sby-single-videos-header"
      >
        <VideosTable />
        <StickyWidget />
        {showImportPopup && (
          <ImporterPopup
            hideCallback={() => {
              setShowImportPopup(false);
            }}
          />
        )}
      </SettingPage>
    </>
  );
};

export default SingleVideos;
